// might move to reusable/UI

import React, { ReactElement, useRef } from 'react';

// import { SendbirdTypes } from '../../../types';

import Avatar from '../../../ui/Avatar';
import MutedAvatarOverlay from '../../../ui/Avatar/MutedAvatarOverlay';
import
  Label,
  {
    LabelStringSet,
    LabelTypography,
    LabelColors,
  } from '../../../ui/Label';

import './user-list-item.scss';

const COMPONENT_NAME = 'sendbird-user-list-item--small';

interface ActionProps {
  actionRef: React.RefObject<HTMLInputElement>;
  parentRef: React.RefObject<HTMLInputElement>;
}

interface CustomUser {
  role: string;
  profileUrl: string;
  nickname: string;
  userId: string;
  isMuted: boolean;
}

interface Props {
  // user: SendbirdTypes["User"] | SendbirdTypes["Member"];
  user: CustomUser;
  currentUser?: string;
  className?: string;
  action?(props: ActionProps): ReactElement;
}

const UserListItem = ({
  user,
  className,
  currentUser,
  action,
}: Props): ReactElement => {
  const actionRef = useRef(null);
  const parentRef = useRef(null);
  const injectingClassNames = Array.isArray(className) ? className : [className];
  return (
    <div
      ref={parentRef}
      className={[
        COMPONENT_NAME, ...injectingClassNames,
      ].join(' ')}
    >
      {
        user.isMuted && (
          <MutedAvatarOverlay />
        )
      }
      <Avatar
        className={`${COMPONENT_NAME}__avatar`}
        src={user.profileUrl}
        width={24}
        height={24}
      />
      <Label
        className={`${COMPONENT_NAME}__title`}
        type={LabelTypography.SUBTITLE_1}
        color={LabelColors.ONBACKGROUND_1}
      >
        {user.nickname || LabelStringSet.NO_NAME}
        {
          (currentUser === user.userId) && (
            " (You)"
          )
        }
      </Label>
      { // if there is now nickname, display userId
        !user.nickname && (
          <Label
            className={`${COMPONENT_NAME}__subtitle`}
            type={LabelTypography.CAPTION_3}
            color={LabelColors.ONBACKGROUND_2}
          >
            {user.userId}
          </Label>
        )
      }
      {
        user.role === 'operator' && (
          <Label
            className={`${COMPONENT_NAME}__operator`}
            type={LabelTypography.SUBTITLE_2}
            color={LabelColors.ONBACKGROUND_2}
          >
            Operator
          </Label>
        )
      }
      {
        action && (
          <div ref={actionRef} className={`${COMPONENT_NAME}__action`}>
            { action({ actionRef, parentRef }) }
          </div>
        )
      }
    </div>
  );
}

export default UserListItem;
